import PropTypes from 'prop-types';
import * as Yup from 'yup';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import {
  LinearProgress,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
// components
import axiosInstance from 'src/api/axiosInstance';
import Iconify from 'src/components/iconify';
import { RHFUpload, RHFUploadBox } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/form-provider';
import { useBoolean } from 'src/hooks/use-boolean';
import {
  getCurrentProject,
  getCurrentServer,
  getMandEndPoint,
  getCurrentSocketServer,
} from 'src/helper/server-address';
import { useSnackbar } from 'src/components/snackbar';
import useNavigateErrorHandler from 'src/hooks/useNavigateErrorHandler';
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies
import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';

export default function ImportExcelDialog({
  open,
  onClose,
  screen,
  setCandidateListRefresh,
  candidateListRefresh,
  ...other
}) {
  const token = sessionStorage.getItem('token');

  const [excelFileNm, setExcelFileNm] = useState('');
  // const [progress, setProgress] = useState({ processCount: 0, totalCount: 0 });
  const [totalRec, setTotalRec] = useState('');
  const [failedRec, setFailedRec] = useState('');
  const [successRec, setSuccessRec] = useState('');
  const [filePathex, setFilePathex] = useState('');
  const loadingSend = useBoolean();
  const excelSchema = Yup.object().shape({});
  const { enqueueSnackbar } = useSnackbar();
  const handleApiError = useNavigateErrorHandler();
  const [value, setValues] = useState();
  const [resumeFileNms, setResumeFileNms] = useState([]);
  const [failedSkills, setFailedSkills] = useState(null);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isUploadComplete, setIsUploadComplete] = useState(false);

  const isUploadEnabled = excelFileNm && resumeFileNms.length > 0;

  const defaultValues = useMemo(
    () => ({
      excelUpload: null,
    }),
    []
  );
  const methods = useForm({
    resolver: yupResolver(excelSchema),
    mode: 'onChange',
    defaultValues,
  });
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = methods;

  // useEffect(() => {
  //   const eventSource = new EventSource(
  //     `/rest/candidate/sseConnection?token=${encodeURIComponent(
  //       token
  //     )}`
  //   );

  //   eventSource.onmessage = (event) => {
  //     setProgress(event.data);
  //     if (event.processCount === event.totalCount) {
  //       setProgress({ processCount: event.totalCount, totalCount: event.totalCount });
  //     }
  //   };

  //   eventSource.onerror = () => {
  //     eventSource.close();
  //     // setProgress('Error occurred while fetching progress.');
  //   };

  //   return () => {
  //     eventSource.close();
  //   };
  // }, [token]);

  // useEffect(() => {
  //   // Check if token is available
  //   if (!token) {
  //     console.error('No token found!');
  //     return;
  //   }

  //   // Create the WebSocket client
  //   const client = new Client({
  //     // brokerURL: 'wss://cmintraapi.cybermeru.com/rest/ws', // WebSocket URL
  //     brokerURL: `${getCurrentSocketServer()}/rest/ws`,
  //     connectHeaders: {
  //       Authorization: `Bearer ${token}`, // Attach the Bearer token
  //     },
  //     debug: (str) => console.log(str), // Log WebSocket debug info
  //     onConnect: () => {
  //       console.log('Connected to WebSocket');
  //       client.subscribe('/topic/progress', (message) => {
  //         const data = JSON.parse(message.body);
  //         console.log('Received WebSocket message:', data);
  //         setProgress(data); // Update progress state
  //       });
  //     },
  //     onStompError: (frame) => {
  //       console.error('STOMP protocol error:', frame);
  //     },
  //     webSocketFactory: () =>
  //       new SockJS(
  //         `/rest/ws?token=${token}`
  //       ),
  //   });

  //   // Activate WebSocket client
  //   client.activate();

  //   // Cleanup on component unmount
  //   // eslint-disable-next-line consistent-return
  //   return () => {
  //     client.deactivate(); // Clean up WebSocket connection
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []); // Recreate WebSocket connection if token changes

  const handleDropResume = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      setExcelFileNm(file.name);
      const newFile = Object.assign(file, {
        preview: URL.createObjectURL(file),
      });
      if (newFile) {
        setValue('excelUpload', newFile, { shouldValidate: true });
      }
    },
    [setValue, setExcelFileNm]
  );

  const handleDrop = useCallback(
    (acceptedFiles) => {
      if (!acceptedFiles || acceptedFiles.length === 0) {
        console.error('No files were accepted.');
        return;
      }
      const file1 = acceptedFiles[0];
      if (file1) {
        setResumeFileNms(file1.name);
      }

      console.log(acceptedFiles, 'Accepted files');

      setValue('isoCerts', (currentFiles = []) => {
        const existingFiles = currentFiles.map((file) => `${file.name}-${file.lastModified}`);

        const newFiles = acceptedFiles
          .filter((file) => !existingFiles.includes(`${file.name}-${file.lastModified}`))
          .map((file) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
              key: `${file.name}-${file.lastModified}`,
            })
          );

        return [...currentFiles, ...newFiles];
      });
    },
    [setValue]
  );

  const handleRemoveFile = useCallback(
    (inputFile) => {
      setValue('isoCerts', (currentFiles = []) => {
        const updatedFiles = currentFiles.filter((file) => file.key !== inputFile.key);

        if (inputFile.preview) {
          URL.revokeObjectURL(inputFile.preview);
        }

        return updatedFiles;
      });
    },
    [setValue]
  );

  const handleRemoveExcel = useCallback(() => {
    setValue('excelUpload', null);
    setExcelFileNm('');
  }, [setValue, setExcelFileNm]);

  const handleDownloadClick = () => {
    try {
      const filePath = '/assets/ReqExcel/Candidate_Data_Template.xlsx';
      const link = document.createElement('a');
      link.href = filePath;
      link.setAttribute('download', 'Candidate_Data_Template.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error(error);
      handleApiError(error);
    }
  };

  const downloadFailedExcel = async (resumePath) => {
    try {
      const response = await axiosInstance.get(
        `/rest/candidate/download-resume?path=${encodeURIComponent(
          resumePath
        )}&fileType=${encodeURIComponent("FAILED_EXCEL")}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data && response.data.downloadUrl) {
        window.open(response.data.downloadUrl, '_blank');
      } else {
        console.error("Invalid response from server:", response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onSubmit = handleSubmit(async (data) => {
    loadingSend.onTrue();
    const user = JSON.parse(localStorage.getItem('user'));
    const subscr = JSON.parse(localStorage.getItem('selectedSubscrSite'));
    try {
      await new Promise((resolve) => setTimeout(resolve, 500));
      const candidateExtraData = {
         
        createdDate: new Date(),
        
        lastUpdatedDate: new Date(),
        subscrSiteId: subscr.subscrSite,
      };

      const formData = new FormData();
      formData.append('excelF', data.excelUpload);
      formData.append('extraD', JSON.stringify(candidateExtraData));

      const addCandUrl = `/rest/candidate/candImportExcel`;
      const response = await axiosInstance.post(addCandUrl, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const candidateEmails = response.data.validCandidateEmailList;
      const matchedResumes = data.isoCerts.filter((file) => {
        const fileNameWithoutExtension = file.name.replace(/\.(pdf|docx?|doc|txt|rtf)+$/i, '');
        return candidateEmails.includes(fileNameWithoutExtension);
      });

      if (matchedResumes.length > 0) {
        const formData1 = new FormData();
        matchedResumes.forEach((file) => {
          formData1.append('resumeF', file);
        });

        const addResumeUrl = `/rest/candidate/addCandRes`;

        const response1 = await axiosInstance.post(addResumeUrl, formData1, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        enqueueSnackbar('Excel and Resumes Uploaded Successfully!', { variant: 'success' });
      } else {
        enqueueSnackbar('No resumes matched candidate emails.', { variant: 'warning' });
      }

      setFilePathex(response.data.excelPath);
      setTotalRec(response.data.totalRecord);
      setFailedRec(response.data.failedRecord);
      setSuccessRec(response.data.successRecord);
      setFailedSkills([...new Set(response.data.Skills.split(','))]);
      setIsRefresh(true);
      setIsUploadComplete(true);
      // Notification on success
      // enqueueSnackbar('Excel and Resume Files Uploaded Successfully!', { variant: 'success' });
    } catch (error) {
      console.error(error);

      // Ensure loading state is reset in case of error
      loadingSend.onFalse();

      let errorMessage = 'Failed to upload Excel file. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      }
      enqueueSnackbar(errorMessage, { variant: 'error' });
    } finally {
      // Ensure loading state is reset in any case
      loadingSend.onFalse();
    }
  });

  const handleCloseDialog = () => {
    if (isRefresh === true) {
      setCandidateListRefresh(!candidateListRefresh);
      setIsRefresh(false);
    }
    onClose();
    setIsUploadComplete(false);
    setValue('excelUpload', null);
    setExcelFileNm('');
    // setProgress({ processCount: 0, totalCount: 0 });
    setFailedSkills(null);
    setTotalRec('');
    setFailedRec('');
    setSuccessRec('');
    setFilePathex('');
    reset();
  };

  // useEffect(() => {
  //   if (!open) {
  //     setProgress({ processCount: 0, totalCount: 0 });
  //   }
  // }, [open]);

  // const progressPercentage = useMemo(() => {
  //   if (progress.totalCount === 0) return 0;
  //   return (progress.processCount / progress.totalCount) * 100;
  // }, [progress]);

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose} {...other}>
      <DialogTitle sx={{ p: (theme) => theme.spacing(3, 3, 2, 3) }}>Upload Excel file</DialogTitle>
      <FormProvider methods={methods}>
        <DialogContent dividers sx={{ pt: 1, pb: 0, border: 'none' }}>
          <Typography variant="body2">
            Please use this format for excel which you want to upload.{' '}
            <Link
              href="#"
              onClick={() => handleDownloadClick()}
              sx={{
                color: '#1976d2',
                textDecoration: 'underline',
                cursor: 'pointer',
                '&:hover': {
                  color: '#1565c0',
                },
              }}
            >
              Click here to download.
            </Link>
          </Typography>
          <Box
            rowGap={3}
            columnGap={2}
            display="grid"
            gridTemplateColumns={{
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(2, 1fr)',
            }}
          >
            <RHFUploadBox
              name="excelUpload"
              onDrop={handleDropResume}
              acceptFile={{
                'application/vnd.ms-excel': [], // For older Excel files (.xls)
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [], // For newer Excel files (.xlsx)
              }}
              //   onDelete={() => setValue('excelUpload', null, { shouldValidate: true })}
              placeholder={
                <Box
                  rowGap={3}
                  columnGap={2}
                  display="flex"
                  alignItems="center"
                  sx={{ color: 'text.disabled' }}
                  gridTemplateColumns={{
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(2, 1fr)',
                  }}
                >
                  <Iconify icon="eva:cloud-upload-fill" width={40} />
                  <Typography variant="body2">
                    Upload Excel <span style={{ color: 'red', fontWeight: 'bolder' }}>*</span>
                  </Typography>
                </Box>
              }
              sx={{
                py: 1,
                width: 'auto',
                height: 'auto',
                borderRadius: 1.5,
              }}
            />
            <Box
              rowGap={3}
              columnGap={2}
              display="flex"
              alignItems="center"
              sx={{ padding: '8px 0', margin: '4px 0', height: '50%' }}
            >
              {excelFileNm && <Iconify icon="vscode-icons:file-type-excel" width={32} />}
              <Typography variant="body2">
                {!excelFileNm ? 'No file Selected' : excelFileNm}
              </Typography>
              {excelFileNm && (
                <Button variant="text" color="secondary" onClick={handleRemoveExcel}>
                  <Iconify icon="entypo:cross" style={{ color: 'red' }} />
                </Button>
              )}
            </Box>
          </Box>

          {/* {progress.totalCount > 0 && progress.processCount < progress.totalCount && (
            <>
              <LinearProgress
                color="success"
                value={progressPercentage} // Use the calculated percentage for progress
                variant="determinate"
                sx={{ mb: 2, width: 1 }}
              />
              <Typography variant="subtitle1">{`Uploading Record: ${progress.processCount} / ${progress.totalCount}`}</Typography>
            </>
          )} */}

          {totalRec && (
            <>
              <Box display="flex" justifyContent="center" mt={2}>
                <TableContainer
                  component={Paper}
                  sx={{ maxWidth: 500, border: '1px dashed #d3d3d3', borderRadius: 2 }}
                >
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#fafafa' }}>
                        <TableCell
                          align="center"
                          sx={{
                            fontWeight: 'bold',
                            borderBottom: '1px dashed #d3d3d3',
                            borderRight: '1px dashed #d3d3d3',
                            py: 1.5,
                          }}
                        >
                          Total Records
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            fontWeight: 'bold',
                            borderBottom: '1px dashed #d3d3d3',
                            borderRight: '1px dashed #d3d3d3 !important',
                            py: 1.5,
                          }}
                        >
                          Success Records
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ fontWeight: 'bold', borderBottom: '1px dashed #d3d3d3', py: 1.5 }}
                        >
                          Failed Records
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="center"
                          sx={{
                            borderBottom: '1px dashed #d3d3d3',
                            borderRight: '1px dashed #d3d3d3',
                            py: 1.2,
                          }}
                        >
                          {totalRec}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            color: 'green',
                            borderBottom: '1px dashed #d3d3d3',
                            borderRight: '1px dashed #d3d3d3 !important',
                            py: 1.2,
                          }}
                        >
                          {successRec}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ color: 'red', borderBottom: '1px dashed #d3d3d3', py: 1.2 }}
                        >
                          {failedRec}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {failedSkills[0] !== '' && (
                <>
                  <Typography variant="body2" sx={{ fontWeight: 'normal', color: 'black', mt: 2 }}>
                    Skills Not Found:{' '}
                    <span style={{ color: 'red', fontWeight: 'normal' }}>
                      {failedSkills.join(', ')}
                    </span>
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'black', marginTop: 1 }}>
                    Please add these skills to your Skill Master first, and reupload the failed
                    Candidate Excel after correcting the incorrect data.
                  </Typography>
                </>
              )}

              {failedRec !== '0' && (
                <Typography variant="body2">
                  Please find the failed record excel{' '}
                  <Link
                    href="#1"
                    onClick={() => downloadFailedExcel(filePathex)}
                    sx={{
                      color: '#1976d2',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      '&:hover': {
                        color: '#1565c0',
                      },
                    }}
                  >
                    Click here to download.
                  </Link>
                </Typography>
              )}
            </>
          )}

          <RHFUpload
            multiple
            typo="Drop Or Select Multiple Resume Files"
            name="isoCerts"
            maxSize={3145728}
            acceptFile={{
              'application/pdf': [],
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
              'application/msword': [],
              'text/plain': [],
            }}
            onDrop={handleDrop}
            onRemove={handleRemoveFile}
          />
          <Typography variant="body2" sx={{ mt: 1, color: 'text.primary' }}>
            Please upload resumes with the naming format{' '}
            <Box component="span" sx={{ color: 'primary.main' }}>
              : candidateEmail.pdf/docx/txt
            </Box>
            .
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary', fontStyle: 'italic' }}>
            (e.g. abc@gmail.com.pdf/docx/txt)
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            variant="soft"
            color="info"
            startIcon={<Iconify icon="carbon:view" />}
            onClick={handleCloseDialog}
          >
            Back To List
          </Button>

          {!isUploadComplete && (
            <Button
              type="submit"
              variant="soft"
              color="primary"
              startIcon={<Iconify icon="eva:cloud-upload-fill" />}
              disabled={!isUploadEnabled}
              loading={loadingSend.value}
              onClick={onSubmit}
            >
              Upload
            </Button>
          )}
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
ImportExcelDialog.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  screen: PropTypes.string,
  setCandidateListRefresh: PropTypes.func,
  candidateListRefresh: PropTypes.bool,
};
